import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MaintenanceService } from '../services/maintenance.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard implements CanActivate {
  constructor(private maintenanceService: MaintenanceService, private router: Router) {}

  public async canActivate(): Promise<any> {
    if (await this.maintenanceService.isUnderMaintenance()) {
      return true;
    } else {
      return this.router.parseUrl('/');
    }
  }
}
